"use client";

import Script from "next/script";

export function KakaoTalkChatButton() {
  return (
    <div>
      <div
        id="kakao-talk-channel-chat-button"
        data-channel-public-id="_xfkRxoG"
        data-title="consult"
        data-size="small"
        data-color="yellow"
        data-shape="mobile"
        data-support-multiple-densities="true"
      ></div>
      <Script
        id="kakao-script"
        // eslint-disable-next-line @eslint-react/dom/no-dangerously-set-innerhtml
        dangerouslySetInnerHTML={{
          __html: `window.kakaoAsyncInit = () => {
            Kakao.Channel.createChatButton({
              container: "#kakao-talk-channel-chat-button",
            });
          };`,
        }}
      />
      <Script
        crossOrigin="anonymous"
        integrity="sha384-8oNFBbAHWVovcMLgR+mLbxqwoucixezSAzniBcjnEoumhfIbMIg4DrVsoiPEtlnt"
        src="https://t1.kakaocdn.net/kakao_js_sdk/2.7.4/kakao.channel.min.js"
      />
    </div>
  );
}

declare global {
  function kakaoAsyncInit(): void;
  namespace Kakao {
    namespace Channel {
      function createChatButton(props: { container: string }): void;
    }
  }
}
